import { FULL_DISCLAIMER } from "../data/lots";
import { Link } from "react-router-dom";
import { scrollToId } from "../lib/scroll";

const NAV = [
  { label: "Available Lots", id: "lots" },
  { label: "About Woodlake", id: "about" },
  { label: "Contact", id: "contact" },
  { label: "Privacy Policy", id: "disclaimer" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-forest text-cream">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
      <div className="grid lg:grid-cols-12 gap-12 pb-14 border-b border-cream/15">
        <div className="lg:col-span-5">
          <p className="font-serif text-3xl tracking-tight">
            BuildInWoodlake<span className="italic text-brass">.com</span>
          </p>
          <p className="mt-4 font-sans text-sm leading-relaxed text-cream/60 max-w-sm">
            Residential homesites available in Woodlake Estates.
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="font-sans text-xs tracking-[0.25em] uppercase text-brass font-semibold mb-5">Contact</p>
          <p className="font-serif text-xl">Brandy Bazile</p>
          <a href="tel:5043296166" className="block mt-2 font-sans text-sm text-cream/70 hover:text-brass transition-colors duration-300">
            504-329-6166
          </a>
          <a href="mailto:brandy4lsu@cox.net" className="block mt-1 font-sans text-sm text-cream/70 hover:text-brass transition-colors duration-300">
            brandy4lsu@cox.net
          </a>
        </div>
        <div className="lg:col-span-4">
          <p className="font-sans text-xs tracking-[0.25em] uppercase text-brass font-semibold mb-5">Explore</p>
          <nav className="flex flex-col gap-3">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`footer-nav-${n.id}`}
                onClick={() => scrollToId(n.id)}
                className="text-left font-sans text-sm text-cream/70 hover:text-brass transition-colors duration-300 w-fit"
              >
                {n.label}
              </button>
            ))}
            <Link data-testid="footer-nav-gallery" to="/gallery" className="text-left font-sans text-sm text-cream/70 hover:text-brass transition-colors duration-300 w-fit">
              Photo Gallery
            </Link>
          </nav>
        </div>
      </div>

      <div id="disclaimer" data-testid="site-disclaimer" className="py-10 border-b border-cream/15">
        <p className="font-sans text-xs leading-relaxed text-cream/45 max-w-5xl">{FULL_DISCLAIMER}</p>
      </div>

      <div className="pt-8 flex flex-wrap items-center justify-between gap-4">
        <p className="font-sans text-xs text-cream/50">© 2026 BuildInWoodlake.com. All rights reserved.</p>
        <p className="font-sans text-xs text-cream/35">Woodlake Estates · Lake Pontchartrain Levee</p>
      </div>
    </div>
  </footer>
);
